import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { forwardRef } from "react";

const MODAL_SHELL_SX = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(680px, calc(100vw - 32px))",
  maxHeight: "calc(100vh - 48px)",
  bgcolor: "background.paper",
  boxShadow: "0 32px 80px rgba(15, 23, 42, 0.24)",
  p: 0,
  borderRadius: "30px",
  overflow: "hidden",
  border: "1px solid rgba(255,255,255,0.6)",
};

const ACCENT_STYLES = {
  info: {
    headerClassName:
      "relative flex h-[120px] w-full items-center justify-center overflow-hidden border-b border-white/25 bg-[linear-gradient(135deg,rgba(88,207,255,0.98)_0%,rgba(0,171,236,0.95)_48%,rgba(120,218,255,0.9)_100%)] shadow-[inset_0_1px_0_rgba(255,255,255,0.22)] backdrop-blur-xl",
    titleClassName: "text-[#00abec]",
  },
  warning: {
    headerClassName:
      "relative flex h-[120px] w-full items-center justify-center overflow-hidden border-b border-white/25 bg-[linear-gradient(135deg,rgba(255,147,87,0.98)_0%,rgba(241,93,34,0.95)_52%,rgba(255,124,50,0.92)_100%)] shadow-[inset_0_1px_0_rgba(255,255,255,0.22)] backdrop-blur-xl",
    titleClassName: "text-[#f15d22]",
  },
};

const ModalShell = forwardRef(function ModalShell(
  {
    accent = "info",
    children,
    contentClassName = "",
    icon,
    onClose,
    width,
  },
  ref
) {
  const accentStyles = ACCENT_STYLES[accent] || ACCENT_STYLES.info;

  return (
    <Box ref={ref} sx={{ ...MODAL_SHELL_SX, ...(width ? { width } : {}) }}>
      <div className={accentStyles.headerClassName}>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.18),transparent_58%)]" />
        <div className="relative flex h-[62px] w-[62px] items-center justify-center rounded-full border border-white/40 bg-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.3)]">
          {icon}
        </div>

        <IconButton
          sx={{
            position: "absolute",
            right: 14,
            top: 14,
            color: "#FFFFFF",
            backgroundColor: "rgba(255,255,255,0.12)",
            border: "1px solid rgba(255,255,255,0.18)",
            backdropFilter: "blur(10px)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.18)",
            },
          }}
          onClick={onClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </div>

      <div
        className={`flex max-h-[calc(100vh-168px)] w-full flex-col overflow-auto px-7 py-6 md:px-8 md:py-7 ${contentClassName}`.trim()}
      >
        {children}
      </div>
    </Box>
  );
});

function ModalTitle({ accent = "info", children, className = "" }) {
  const accentStyles = ACCENT_STYLES[accent] || ACCENT_STYLES.info;

  return (
    <h3
      className={`mb-4 text-[24px] font-black ${accentStyles.titleClassName} ${className}`.trim()}
    >
      {children}
    </h3>
  );
}

export default ModalShell;
export { ModalTitle };
